import React, { useMemo } from 'react';

const RosterSummaryTable = ({ rosterSummary }) => {
    const hasData = rosterSummary && rosterSummary.length > 0;

    const emptyWeekColumns = useMemo(() => {
        const today = new Date();
        const dayOfWeek = today.getDay();
        const monday = new Date(today);
        monday.setDate(today.getDate() - ((dayOfWeek + 6) % 7));

        const cols = [''];
        for (let i = 0; i < 7; i++) {
            const d = new Date(monday);
            d.setDate(monday.getDate() + i);
            const label = d.toLocaleDateString('en-GB', { weekday: 'short', day: '2-digit', month: '2-digit' });
            cols.push(label);
        }
        return cols;
    }, []);

    const transformData = (data) => {
        const columns = [""]; // First column for row labels
        const currentRow = { "": { value: "Current" } };
        const previousYearRow = { "": { value: "Previous Year" } };

        data.forEach(item => {
            columns.push(item.dateTimeDescription);
            currentRow[item.dateTimeDescription] = { value: item.shifts, cellColour: item.cellColour };
            previousYearRow[item.dateTimeDescription] = {
                value: item.previousYear === "0" ? "" : item.previousYear
            };
        });

        return { columns, rows: [currentRow, previousYearRow] };
    };

    const { columns, rows } = useMemo(
        () => hasData ? transformData(rosterSummary) : { columns: emptyWeekColumns, rows: [] },
        [rosterSummary, hasData, emptyWeekColumns]
    );

    return (
        <div className="roster-summary-grid">
            <div
                className="summary-grid-inner"
                style={{ gridTemplateColumns: `repeat(${columns.length}, 1fr)` }}
            >
                {columns.map((column, index) => (
                    <div key={index} className="summary-header-cell">
                        {column}
                    </div>
                ))}

                {!hasData ? (
                    <div
                        className="summary-empty-message"
                        style={{ gridColumn: `1 / ${columns.length + 1}` }}
                    >
                        No data available
                    </div>
                ) : (
                    rows.map((row, rowIndex) => (
                        columns.map((column, colIndex) => {
                            const cellData = row[column];
                            const isLabel = colIndex === 0;
                            const hasColour = !!cellData?.cellColour;

                            if (isLabel) {
                                return (
                                    <div key={`${rowIndex}-${colIndex}`} className="summary-label-cell">
                                        {cellData?.value}
                                    </div>
                                );
                            }

                            return (
                                <div
                                    key={`${rowIndex}-${colIndex}`}
                                    className={`summary-data-cell${hasColour ? ' summary-data-cell--coloured' : ''}`}
                                    style={hasColour ? { backgroundColor: cellData.cellColour } : undefined}
                                >
                                    {cellData?.value}
                                </div>
                            );
                        })
                    ))
                )}
            </div>
        </div>
    );
};

export default RosterSummaryTable;
